import { Component, Inject, OnInit, ChangeDetectionStrategy } from '@angular/core'
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog'

@Component({
    selector: 'confirmation-legacy-component',
    // templateUrl: './confirmation-legacy.component.html',
    templateUrl: './confirmation-legacy.v2.component.html',
    styleUrls: ['./confirmation-legacy.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ConfirmationLegacyComponent implements OnInit {
  constructor(
    public dialogRef: MatDialogRef<ConfirmationLegacyComponent>,
    @Inject(MAT_DIALOG_DATA) public data: string
  ) {}

  ngOnInit(): void {
    if (!this.data) {
      this.data = 'Você tem certeza de que deseja realizar esta ação?'
    }
  }

  onNoClick(): void {
    this.dialogRef.close()
  }
}
